import socketIo from "socket.io-client";

// "undefined" means the URL will be computed from the `window.location` object
const URL = "https://api-socket.blueberrypiestaging.com";

export const socket = (id) => {
  const socketInstance = socketIo(URL, {
    query: { id },
    transports: ["websocket"],
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000,
    timeout: 20000,
  });

  // Debugging logs for socket events
  socketInstance.on("connect", () => {
    // console.log("Socket connected");
  });

  socketInstance.on("disconnect", (reason) => {
    // console.log("Socket disconnected:", reason);
  });

  socketInstance.on("reconnect", (attempt) => {
    // console.log("Socket reconnected on attempt:", attempt);
  });

  socketInstance.on("connect_error", (error) => {
    console.error("Socket connection error:", error);
  });

  return socketInstance;  
};
